/**
 * TODO finish implementation
 *
 * @module
 * @import {ListPosition} from "@acng/frontend-discovery"
 */

export {CLICK_SCROLL};

import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {localValue, Watch} from '@acng/frontend-relativity';
import {ENUM, guard, IS} from '@acng/frontend-rubicon';
// bounty
import {scroll} from '@acng/frontend-bounty/style/view.js';
import {CLICK, on} from '@acng/frontend-bounty/dom/event.js';
import {hide, show} from '@acng/frontend-bounty/style/element.js';

import {ctxListPosition} from '../context/list-position.js';

/**
 * @group DOM Attribute
 */
const CLICK_SCROLL = 'click-scroll';

AttributeSetup(CLICK_SCROLL, (name) => {
  const OPTIONS = /** @type {const} */ (['up', 'down']);
  const watch = Watch(`[${name}]`, ctxListPosition);

  /**
   * @type {Record<OPTIONS[number], (pos: ListPosition) => boolean>}
   */
  const visibility = {
    up: ({head, first}) => head != first,
    down: ({last, tail}) => last != tail,
  };

  /**
   * @type {Record<OPTIONS[number], (pos: ListPosition) => void>}
   */
  const action = {
    up: ({scrollingElement, head}) => {
      if (head) {
        scroll(
          scrollingElement,
          head.offsetTop - scrollingElement.clientHeight,
          head.offsetLeft - scrollingElement.clientWidth,
          'smooth'
        );
      }
    },
    down: ({scrollingElement, tail}) => {
      if (tail) {
        scroll(scrollingElement, tail.offsetTop, tail.offsetLeft, 'smooth');
      }
    },
  };

  AttributeLink(name, (element, value) => {
    ASSERT: {
      guard(element, IS(HTMLElement));
      guard(value, ENUM(OPTIONS));
    }

    on(element, CLICK, () => action[value](localValue(element, ctxListPosition)));

    watch(element, (element, pos) => {
      if (visibility[value](pos)) {
        show(element);
      } else {
        hide(element);
      }
    });
  });
});
